export default class {

	constructor(obj) {
		this.id = obj.id
		this.value = obj.value
		this.filterTypeId = obj.filtertype_id
		this.filterParameter = obj.filterParameter
	}
}



// WEBPACK FOOTER //
// ./src/dashboard/dto/DtoFilter.js